import { jsonldReviewPublisher } from './JsonldStore';

export const updateJsonldReviewPublisher = (value) => jsonldReviewPublisher.update((oldValue) => value);
